import { useGameStore } from '@hollowveil/shared';
import { WorldIndicator } from './WorldIndicator';
import { TouchControls } from './TouchControls';
import { MessageBox } from './MessageBox';
import { WorldTransition } from './WorldTransition';
import { QuestUI } from './QuestUI';
import { GameToolbar } from './GameToolbar';
import { RiddleUI } from './RiddleUI';
import { ZoomControls } from './ZoomControls';
import './GameUI.css';

export function GameUI() {
  const { inputMode, isPaused } = useGameStore();

  if (isPaused) {
    return (
      <div className="game-ui">
        <div className="pause-menu">
          {/* TODO: Pause menu */}
        </div>
      </div>
    );
  }

  return (
    <div className="game-ui">
      <QuestUI />
      <WorldIndicator />
      <MessageBox />
      <WorldTransition />
      <GameToolbar />
      <RiddleUI />
      <ZoomControls />

      {inputMode === 'touch' && <TouchControls />}
    </div>
  );
}
